import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/auth";
import { formatApiError, startClientGoogle } from "@/lib/clientAuth";
import { AuthShell } from "@/pages/portal/ClientLogin";

const inputCls = "w-full rounded-xl border border-gold/20 bg-obsidian-900 px-4 py-3 text-sm text-ivory outline-none transition focus:border-gold/60";
const btnCls = "w-full rounded-full bg-gold px-6 py-3 font-sans text-sm font-semibold uppercase tracking-[0.12em] text-obsidian-900 transition hover:shadow-[0_0_28px_rgba(212,175,55,0.35)] disabled:opacity-50";

export default function ClientRegister() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/client/auth/register", form);
      setDone(true);
      toast.success(data.message || "Account created");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <AuthShell kicker="Client Portal" title="Check your email" testid="page-register-done">
        <p className="text-center text-sm leading-relaxed text-ivory/70">
          We've sent a verification link to <span className="text-gold">{form.email}</span>. Verify your email, then sign in.
        </p>
        <button onClick={() => nav("/login")} data-testid="register-done-signin" className={`${btnCls} mt-8`}>Go to Sign In</button>
      </AuthShell>
    );
  }

  return (
    <AuthShell kicker="Client Portal" title="Create Account" testid="page-register">
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="register-name" required placeholder="Full name" value={form.name} onChange={set("name")} className={inputCls} />
        <input data-testid="register-email" type="email" required placeholder="Email" value={form.email} onChange={set("email")} className={inputCls} />
        <input data-testid="register-password" type="password" required minLength={8} placeholder="Password (min 8 characters)" value={form.password} onChange={set("password")} className={inputCls} />
        <button data-testid="register-submit" disabled={loading} className={btnCls}>{loading ? "Creating…" : "Create Account"}</button>
      </form>
      <div className="my-5 flex items-center gap-3 text-ivory/30"><div className="h-px flex-1 bg-gold/15" /><span className="text-[10px] uppercase tracking-widest">or</span><div className="h-px flex-1 bg-gold/15" /></div>
      <button data-testid="register-google" onClick={startClientGoogle} className="w-full rounded-full border border-gold/30 px-6 py-3 text-sm font-semibold text-ivory transition hover:bg-gold/10">Continue with Google</button>
      <p className="mt-6 text-center text-sm text-ivory/60">Already registered? <Link to="/login" className="text-gold hover:underline">Sign in</Link></p>
    </AuthShell>
  );
}
